var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.186 12.134v30.602h25.472v5.13H60v-5.13h45.814V12.134z",
    fill: "#cb3837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.398 17.264H19.315v20.342h10.083V22.394h5.13v15.213h5.13V17.264zm15.4 0v25.472h10.26v-5.13H65.13V17.264zM60 32.476h-4.953V22.394H60zm20.342-15.212H70.26v20.342h10.083V22.394h5.13v15.213h5.13V22.394h5.13v15.213h5.13V17.264z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.9c45979bc6a8b444de410e2e4586c1f6.svg";
export { ForwardRef as ReactComponent };